import React from 'react'
import { FormControl, MenuItem, Typography, Select } from '@mui/material'

import { useDevices } from '@daily-co/daily-react'

export default function AudioOutputList() {
  const { currentSpeaker,speakers, setSpeaker } = useDevices()
  const updateSpeakers = (e:any) => {
    setSpeaker(e.target.value)
  }

  return (
    <div>
      {speakers.length > 1 ? (
        <FormControl 
          fullWidth>
          <Typography 
            variant="subtitle2" 
            gutterBottom>
            Audio Output
          </Typography>
          <Select 
            onChange={updateSpeakers} 
            value={currentSpeaker?.device?.deviceId || ''}
            variant="outlined">
            {speakers.map(device => (
              <MenuItem 
                value={device.device.deviceId} 
                key={device.device.deviceId} >
                {device.device.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      ) : (
        <>
          <Typography 
            variant="subtitle2">
            Audio Output
          </Typography>
          <Typography>{currentSpeaker?.selected || 'System Default Audio Output'}</Typography>
        </>
      )}
    </div>
  );
}
